export var DEFAULT_ICON_SIZE = 24;
//# sourceMappingURL=constants.js.map